import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/ManagedRepairOrders/actions";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import ShippingFields from "MODULES/Orders/shared/ShippingFields/ShippingFields";
import {
  COMPANY,
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_FOB,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE
} from "APP_ROOT/constants";
import { DROPSHIP } from "MODULES/PurchaseOrders/constants";
import { Col } from "react-bootstrap";
import { Field } from "redux-form";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { properCase } from "LIB/formatters/text";
import { validateShipping } from "./validate";

const FORM_NAME = "editReturnToManagedRepairShipping";

export function Form(props) {
  const { managedRepairOrder } = props;
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <ShippingFields
          formName={FORM_NAME}
          hasLocations={false}
          shipToCompany={managedRepairOrder.return_to_company}
          shippingFields={[
            RETURN_TO_TYPE,
            RETURN_TO_COMPANY_ID,
            RETURN_TO_COMPANY_ADDRESS_ID
          ]}
          shippingMethod={RETURN_TO_SHIPPING_METHOD}
          shippingTypes={[COMPANY, DROPSHIP]}
          shippingAddressField={RETURN_TO_SHIPPING_ADDRESS}
        >
          <FormRow>
            <Col md={7}>
              <Field
                name={RETURN_TO_FOB}
                component={FormInput}
                label={properCase(RETURN_TO_FOB)}
                required
              />
            </Col>
          </FormRow>
        </ShippingFields>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  managedRepairOrder: PropTypes.shape({
    ship_to_company: PropTypes.instanceOf(Object)
  })
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.update(data))
}))(
  form({
    form: FORM_NAME,
    validate: validateShipping
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/ReturnToShippingDetails/Form.jsx